import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { ReactComponent as AccountRed } from '../../../static/icons/account-red.svg';
import { ReactComponent as AccountWhite } from '../../../static/icons/account-white.svg';
import { ReactComponent as Alarm } from '../../../static/icons/alarm.svg';
import { ReactComponent as ArrowDownSmall } from '../../../static/icons/arrow-down-small.svg';
import { ReactComponent as ArrowLeftLarge } from '../../../static/icons/arrow-left-large.svg';
import { ReactComponent as ArrowLeftNormal } from '../../../static/icons/arrow-left-normal.svg';
import { ReactComponent as ArrowLeftSmall } from '../../../static/icons/arrow-left-small.svg';
import { ReactComponent as ArrowRightLarge } from '../../../static/icons/arrow-right-large.svg';
import { ReactComponent as ArrowRightNormal } from '../../../static/icons/arrow-right-normal.svg';
import { ReactComponent as ArrowRightSmall } from '../../../static/icons/arrow-right-small.svg';
import { ReactComponent as ArrowUpFromSquare } from '../../../static/icons/arrow-up-right-from-square.svg';
import { ReactComponent as ArrowUpSmall } from '../../../static/icons/arrow-up-small.svg';
import { ReactComponent as Award } from '../../../static/icons/award.svg';
import { ReactComponent as Book } from '../../../static/icons/book.svg';
import { ReactComponent as Calendar } from '../../../static/icons/calendar.svg';
import { ReactComponent as Clipboard } from '../../../static/icons/clipboard.svg';
import { ReactComponent as Clock } from '../../../static/icons/clock.svg';
import { ReactComponent as Download } from '../../../static/icons/download.svg';
import { ReactComponent as Euro } from '../../../static/icons/euro.svg';
import { ReactComponent as Facebook } from '../../../static/icons/facebook.svg';
import { ReactComponent as FileText } from '../../../static/icons/file-text.svg';
import { ReactComponent as Flag } from '../../../static/icons/flag.svg';
import { ReactComponent as Instagram } from '../../../static/icons/instagram.svg';
import { ReactComponent as language } from '../../../static/icons/language.svg';
import { ReactComponent as Linkedin } from '../../../static/icons/linkedin.svg';
import { ReactComponent as Location } from '../../../static/icons/map-pin.svg';
import { ReactComponent as MenuBurger } from '../../../static/icons/menu-burger.svg';
import { ReactComponent as MenuClose } from '../../../static/icons/menu-close.svg';
import { ReactComponent as Message } from '../../../static/icons/message.svg';
import { ReactComponent as PlusSquare } from '../../../static/icons/plus-square.svg';
import { ReactComponent as Search } from '../../../static/icons/search.svg';
import { ReactComponent as Settings } from '../../../static/icons/settings.svg';
import { ReactComponent as Tiktok } from '../../../static/icons/tiktok.svg';
import { ReactComponent as TwitterRetweet } from '../../../static/icons/twitter-retweet.svg';
import { ReactComponent as Twitter } from '../../../static/icons/X_logo.svg';
import { ReactComponent as Youtube } from '../../../static/icons/youtube.svg';
import * as iconStyles from '../../styles/communs/icon.module.scss';

const IconContainer = (props) => {
  const {
    icon,
    variant = 'basic',
    color,
    size,
    hoverColor,
    noHover,
    tabIndex,
    onClick,
    onKeyPress,
    id,
    classname,
    svgClassname,
    style,
    label,
    notHidden,
  } = props;
  const [hover, setHover] = useState(false);

  const getBasicColor = () => {
    if (color === 'RED') return 'var(--red-color)';
    if (color === 'BLACK') return 'var(--dark-color)';
    return 'var(--white-color)';
  };

  const getContainedFillColor = () => {
    if (color === 'BLACK' || color === 'RED') return 'var(--white-color)';
    return 'var(--red-color)';
  };

  const getHoverBasicColor = () => {
    if (noHover) return '';
    if (hoverColor) {
      if (hoverColor === 'RED') return 'var(--white-color)';
      return 'var(--red-color)';
    }
    if (color === 'RED') return 'var(--white-color)';
    return 'var(--red-color)';
  };

  const getHoverContainedBackgroundColor = () => {
    if (noHover) return '';
    if (color === 'WHITE') return 'var(--red-color)';
    return 'var(--white-color)';
  };

  const getHoverContainedColor = () => {
    if (noHover) return '';
    if (color === 'WHITE') return 'var(--white-color)';
    if (color === 'RED') return 'var(--red-color)';
    return 'var(--dark-color)';
  };

  const classes = {
    icon: {
      height: size ? size + 'px' : '50px',
      width: size ? size + 'px' : '50px',
    },
    basic: {
      fill: getBasicColor(),
      color: getBasicColor(),
    },
    outlined: {
      borderRadius: '50%',
      height: size ? size + 'px' : '30px',
      width: size ? size + 'px' : '30px',
      fill: color === 'BLACK' ? 'var(--dark-color)' : 'var(--red-color)',
      color: color === 'BLACK' ? 'var(--dark-color)' : 'var(--red-color)',
      border: color === 'BLACK' ? '1px solid var(--dark-color)' : '1px solid var(--red-color)',
      padding: '10px',
    },
    full: {
      borderRadius: '50%',
      backgroundColor: 'var(--white-color)',
      height: size ? size + 'px' : '30px',
      width: size ? size + 'px' : '30px',
      fill: color === 'BLACK' ? 'var(--dark-color)' : 'var(--red-color)',
      color: color === 'BLACK' ? 'var(--dark-color)' : 'var(--red-color)',
      border: color === 'BLACK' ? '1px solid var(--dark-color)' : '1px solid var(--red-color)',
      padding: '6px',
    },
    contained: {
      padding: '15px',
      borderRadius: '50%',
      fill: getContainedFillColor(),
      color: getContainedFillColor(),
      backgroundColor: getBasicColor(),
    },
  };

  const classesHover = {
    basic: {
      color: getHoverBasicColor(),
    },
    contained: {
      backgroundColor: getHoverContainedBackgroundColor(),
      color: getHoverContainedColor(),
      border: `1px solid ${getHoverContainedColor()}`,
    },
  };

  const IconTab = {
    ALARM: Alarm,
    ACCOUNT_RED: AccountRed,
    ACCOUNT_WHITE: AccountWhite,
    ARROW_DOWN_SMALL: ArrowDownSmall,
    ARROW_LEFT_LARGE: ArrowLeftLarge,
    ARROW_LEFT_NORMAL: ArrowLeftNormal,
    ARROW_LEFT_SMALL: ArrowLeftSmall,
    ARROW_RIGHT_LARGE: ArrowRightLarge,
    ARROW_RIGHT_NORMAL: ArrowRightNormal,
    ARROW_RIGHT_SMALL: ArrowRightSmall,
    ARROW_UP_SMALL: ArrowUpSmall,
    ARROW_UP_FROW_SQUARE: ArrowUpFromSquare,
    AWARD: Award,
    BOOK: Book,
    CALENDAR: Calendar,
    CLIPBOARD: Clipboard,
    CLOCK: Clock,
    DOWNLOAD: Download,
    EURO: Euro,
    FACEBOOK: Facebook,
    FILE_TEXT: FileText,
    FLAG: Flag,
    INSTAGRAM: Instagram,
    LANGUAGE: language,
    LINKEDIN: Linkedin,
    LOCATION: Location,
    MENU_BURGER: MenuBurger,
    MENU_CLOSE: MenuClose,
    MESSAGE: Message,
    PLUS_SQUARE: PlusSquare,
    SEARCH: Search,
    SETTINGS: Settings,
    TIKTOK: Tiktok,
    TWITTER: Twitter,
    TWITTER_RETWEET: TwitterRetweet,
    YOUTUBE: Youtube,
  };

  const Comps = IconTab[icon];

  const conditionalAttrLink = {};

  if (label) {
    conditionalAttrLink['aria-label'] = label;
  }

  if (!Comps) return null;

  return (
    <span
      className={clsx(iconStyles.containerIcon, classname, {
        [iconStyles.contained]: variant === 'contained',
        [iconStyles.containerPointer]: !noHover,
      })}
      style={{
        ...classes.icon,
        ...classes[variant],
        ...(hover ? classesHover[variant] : ''),
        ...style,
      }}
    >
      <Comps
        {...conditionalAttrLink}
        aria-hidden={!notHidden}
        className={clsx(iconStyles.icon, svgClassname || '')}
        focusable={notHidden}
        id={id}
        onClick={onClick}
        onKeyDown={onKeyPress}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        tabIndex={tabIndex}
      />
    </span>
  );
};

/* Si tu rajoutes un icon ici, tu le rajoutes dans le tableau de hash et dans sa story*/

IconContainer.propTypes = {
  classname: PropTypes.string,
  color: PropTypes.oneOf(['RED', 'BLACK', 'WHITE']),
  hoverColor: PropTypes.oneOf(['RED', 'WHITE']),
  icon: PropTypes.oneOf([
    'ALARM',
    'ACCOUNT_RED',
    'ACCOUNT_WHITE',
    'ARROW_DOWN_SMALL',
    'ARROW_LEFT_LARGE',
    'ARROW_LEFT_NORMAL',
    'ARROW_LEFT_SMALL',
    'ARROW_RIGHT_LARGE',
    'ARROW_RIGHT_NORMAL',
    'ARROW_RIGHT_SMALL',
    'ARROW_UP_SMALL',
    'AWARD',
    'BOOK',
    'CALENDAR',
    'CLOCK',
    'CLIPBOARD',
    'DOWNLOAD',
    'EURO',
    'FACEBOOK',
    'FILE_TEXT',
    'FLAG',
    'INSTAGRAM',
    'LINKEDIN',
    'LOCATION',
    'MENU_BURGER',
    'MENU_CLOSE',
    'MESSAGE',
    'PLUS_SQUARE',
    'SEARCH',
    'SETTINGS',
    'TIKTOK',
    'TWITTER',
    'TWITTER_RETWEET',
    'YOUTUBE',
  ]),
  id: PropTypes.string,
  label: PropTypes.string,
  noHover: PropTypes.bool,
  notHidden: PropTypes.bool,
  onClick: PropTypes.func,
  onKeyPress: PropTypes.func,
  size: PropTypes.any,
  style: PropTypes.object,
  svgClassname: PropTypes.string,
  tabIndex: PropTypes.any,
  variant: PropTypes.oneOf(['basic', 'outlined', 'full', 'contained', 'icon']),
};

export default IconContainer;
